// @ts-nocheck
import { notEmpty } from "../../../modules/utilities";
import schedule from 'node-schedule'

const jobs = {}

let index = 0
const apptsJobIndex = index++
const companiesJobIndex = index++
const peopleJobIndex = index++
const eventsJobIndex = index++
const newsJobIndex = index++
const synopsisJobIndex = index++
const advisersJobIndex = index++

const lseRule = new schedule.RecurrenceRule()
lseRule.dayOfWeek = [new schedule.Range(1, 5)]
lseRule.hour = 16
lseRule.minute = 30
lseRule.tz = 'GB'

// Get the News meta 5 days a week, 7 until 18, every 10 mins from 1 min past hour
const newsRule = new schedule.RecurrenceRule()
newsRule.dayOfWeek = [new schedule.Range(1, 5)]
newsRule.hour = [new schedule.Range(7, 18)]
newsRule.minute = [new schedule.Range(1, 59, 10)]
newsRule.tz = 'GB'

const synopsisRule = new schedule.RecurrenceRule();
synopsisRule.minute = [0, 10, 20, 30, 40, 50]; // runs at these minutes every hour

var gotUsersCheckboxes = false

export const LoadFavouritesAndLSEs = props => {
  // console.log('LoadFavouritesAndLSEs props:', props)
  const { advisers, features, lse, news, synopsis } = props
  // NB: favourites is initially null then set to {} while we are populating it.
  if (features.LseAppts) {
    scheduleJob(companiesJobIndex, lseRule, lse.getCompaniesMeta)
    scheduleJob(apptsJobIndex, lseRule, lse.getApptsMeta)
    scheduleJob(peopleJobIndex, lseRule, lse.getPeopleMeta)
    scheduleJob(eventsJobIndex, lseRule, lse.getEventsMeta)
    scheduleJob(newsJobIndex, newsRule, news.getMeta)
  }
  else {
    cancelScheduledJob(companiesJobIndex, lse.getCompaniesMeta)
    cancelScheduledJob(apptsJobIndex, lse.setApptsMeta)
    cancelScheduledJob(peopleJobIndex, lse.setPeopleMeta)
    cancelScheduledJob(eventsJobIndex, lse.setEventsMeta)
    cancelScheduledJob(newsJobIndex, news.setMeta)
  }

  if (features.LseAppts && !props.the350club)
    scheduleJob(advisersJobIndex, lseRule, advisers.getAdvisers)
  else
    cancelScheduledJob(advisersJobIndex, advisers.setAdvisers)

  if (features.Developer)
    scheduleJob(synopsisJobIndex, synopsisRule, synopsis.get)
  else
    cancelScheduledJob(synopsisJobIndex, news.setMeta)

  // TODO Consider adding items layer to favourites object
  if (features.Favourites) {
    getFavourites(props)
    getUsersCheckboxes(props)
  } else {
    // If not logged in favourites and lseCompaniesMeta should be null
    setFavourites(props)
    // No user logged in so we need to get the checkboxes when next user to log in
    gotUsersCheckboxes = false
  }

  syncLseFavourites(props)
}

const getFavourites = props => {
  if (props.favourites === null && !props.favouritesFetching)
    props.fav.get()
}

const setFavourites = props => {
  if (props.favourites !== null)
    props.fav.set(null)
}

// Gets the user's checkboxes if not already done so. Also, check that we are not
// refreshing the page, or using a saved url from, for example, an exported csv
const getUsersCheckboxes = props => {
  if (!gotUsersCheckboxes && !window.location.search) {
    props.common.getCheckboxes(props)
    gotUsersCheckboxes = true
  }
}

const scheduleJob = (jobIndex, rule, method) => {
  if (!schedule.scheduledJobs.hasOwnProperty(jobs[jobIndex])) {
    // console.log('scheduleJob jobIndex:', jobIndex)
    method()
    const scheduledJob = (schedule.scheduleJob(rule, method))
    jobs[jobIndex] = scheduledJob.name
  }
}

const cancelScheduledJob = (jobIndex, method) => {
  if (schedule.scheduledJobs.hasOwnProperty(jobs[jobIndex])) {
    // console.log('cancelScheduledJob jobs[jobIndex]:', jobs[jobIndex])
    schedule.scheduledJobs[jobs[jobIndex]].cancel()
    method(null)
  }
}

const syncLseFavourites = props => {
  // console.log('syncLseFavourites props:', props)
  // Sync lse favourite companies
  const { advisersMeta, favourites, lseCompaniesMeta, lsePeopleMeta } = props
  if (props.features.Favourites) {
    // If favourites and lseCompaniesMeta loaded, but lseCompaniesMeta 'isFavourite's
    // have not been set (not synced) then 'sync' lseCompaniesMeta with favourites
    if (notEmpty(favourites)) {
      if (notEmpty(lseCompaniesMeta) && !lseCompaniesMeta.synced)
        props.lse.updateIsFavourite({ lseCompaniesMeta, favourites, })

      if (notEmpty(lsePeopleMeta) && !lsePeopleMeta.synced)
        props.lse.updateIsPersonFavourite({ lsePeopleMeta, favourites, })

      if (notEmpty(advisersMeta) && !props.advisersSynced)
        props.advisers.updateIsFavourite(advisersMeta, favourites)
    }
  }
}

